import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import EventAttendance from "./EventAttendance";

createRoot(document.getElementById("tmt-event-attendance")).render(
  <StrictMode>
    <EventAttendance />
  </StrictMode>
);
